// extracted by mini-css-extract-plugin
export default {"p":"_649ce1be42 _2189c1995a _1ce664d820","clr":"_22542ac826","dls":"ad329ecce4"};